import {createSlice} from '@reduxjs/toolkit';

import MojitoCore from 'mojito/core';

const reduxInstance = MojitoCore.Services.redux;

export const STORE_KEY = 'MetaDataStore';

export const INITIAL_STATE = {
    metaData: null,
};

export const {reducer, actions} = createSlice({
    name: 'meta-data',
    initialState: INITIAL_STATE,
    reducers: {
        setMetaData(state, {payload: metaData}) {
            state.metaData = metaData;
        },
    },
});

reduxInstance.injectReducer(STORE_KEY, reducer);
